import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "../../utils/cn";

export type CardPadding = "none" | "sm" | "md";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Lift to a higher elevation on hover. */
  hoverable?: boolean;
  /** Inner padding density: none, sm (16px) or md (24px). */
  padding?: CardPadding;
}

const paddings: Record<CardPadding, string> = {
  none: "p-0",
  sm: "p-4",
  md: "p-6",
};

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { hoverable = false, padding = "sm", className, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        "rounded-lg border bg-surface shadow",
        hoverable &&
          "transition duration-fast ease-ai21-standard hover:-translate-y-px hover:shadow-lg",
        paddings[padding],
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
});
